<template>
  <div v-if="attrData.length > 0">
    <component class="mr-b25" v-for="(attr, index) in attrData" :class="attrData.length - 1 === index ? 'no-stroke' : ''" :key="attr.attrId" :is="getComponentName(attr)" :ref="attr.attrId"
      :view-type="'SETTING'"
      :default-value="getDefaultValue(attr.attrDefaultValue)"
      :default-set-list="getDefaultValue(attr.attrListSet)"
      :dependent-attr-ids="attr.dependentAttrIds" />
  </div>
  <div v-else>
    보고서 옵션이 없습니다.
  </div>
</template>

<script>
import assign from 'lodash/assign';
import capitalize from 'lodash/capitalize';
import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import WDetailInfoComponent from '@/views/report/attr/DetailInfoComponent';
import WSortComponent from '@/views/report/attr/SortComponent';
import WWatchallGroupsTable from '@/views/report/attr/WatchallGroupsTable';
import WWatchallGroupTable from '@/views/report/attr/WatchallGroupTable';
import WWatchallObjsTree from '@/views/report/attr/WatchallObjsTree';
import WWatchallResourceComponent from '@/views/report/attr/WatchallResourceComponent';

export default {
  name: 'WReportOptionInfoView',
  components: {
    WDetailInfoComponent,
    WSortComponent,
    WWatchallGroupsTable,
    WWatchallGroupTable,
    WWatchallObjsTree,
    WWatchallResourceComponent,
  },
  props: {
    attrData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    /**
     * 템플릿 별 Attribute에 따른 ComponentName 반환
     * @author kimjy
     * @param  {Object} attr Attribute 정보
     * @return {String}      componentName
     */
    getComponentName(attr) {
      const componentNames = attr.attrId.split('_');
      let componentName = 'W';
      forEach(componentNames, (item) => {
        componentName = `${componentName}${capitalize(item)}`;
      });
      return `${componentName}${capitalize(attr.attrTypeId)}`;
    },
    /**
     * 기본 값 설정에 필요한 String 데이터 JSON 변환
     * @author kimjy
     * @param  {String} defaultValueStr 기본 설정 값
     */
    getDefaultValue(defaultValueStr) {
      if (!isEmpty(defaultValueStr)) {
        return JSON.parse(defaultValueStr);
      }
      return null;
    },
    /**
     * 각 Attribute의 initData 함수 호출
     * @author kimjy
     */
    initOptionInfo() {
      this.$nextTick(() => {
        forEach(this.attrData, (item) => {
          this.$refs[item.attrId][0].initData();
        });
      });
    },
    /**
     * 각 Attribute의 getData 함수 호출
     * @author kimjy
     */
    getReportOptionInfo() {
      const resultMap = {};
      for (let i = 0; i < this.attrData.length; i += 1) {
        const returnData = this.$refs[this.attrData[i].attrId][0].getData();
        if (returnData === false) {
          return false;
        }
        assign(resultMap, returnData);
      }
      return resultMap;
    },
    getReportDetailOptionInfo() {
      const resultMap = {};
      for (let i = 0; i < this.attrData.length; i += 1) {
        const returnData = this.$refs[this.attrData[i].attrId][0].getDetailData();
        if (returnData === false) {
          return false;
        }
        assign(resultMap, returnData);
      }
      return resultMap;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/components/ReportOptionInfoView.vue